import React from 'react'
import ReactMarkdown from 'react-markdown/with-html'

import ChakraUIRenderer from 'chakra-ui-markdown-renderer'
type MarkdownProps = {
  content: string | undefined | null
}
const Markdown: React.FC<MarkdownProps> = ({ content }) => {
  return <ReactMarkdown renderers={ChakraUIRenderer()} source={content as string} />
}
export default Markdown
